/* Seorin - tiroir panier : carrello riservato (10 min, par onglet), consegna stimata (jours ouvres),
   bouton "+ Aggiungi 1 sapone" branche sur le champ quantite de Dawn (la remise Kaching suit la quantite).
   Le tiroir est re-rendu par Dawn a chaque changement : tout est relu dans le DOM a chaque tic. */
(function () {
  var MINUTES = 10, KEY = 'seorinCartEnd', memEnd = 0;
  var SOAP_VARIANT = '58662556107126';

  function readEnd() {
    try { return parseInt(sessionStorage.getItem(KEY), 10) || memEnd; } catch (e) { return memEnd; }
  }
  function writeEnd(v) {
    memEnd = v;
    try { sessionStorage.setItem(KEY, String(v)); } catch (e) {}
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var clocks = document.querySelectorAll('[data-seorin-cd-clock]');
    if (!clocks.length) { return; }
    var now = Date.now(), end = readEnd();
    if (!end || end < now) { end = now + MINUTES * 60000; writeEnd(end); }
    var s = Math.floor((end - now) / 1000);
    var txt = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
    for (var i = 0; i < clocks.length; i++) {
      if (clocks[i].textContent !== txt) { clocks[i].textContent = txt; }
    }
  }

  function eta() {}

  /* + Aggiungi 1 sapone : incremente le champ quantite de la ligne savon, Dawn fait la requete et re-rend */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-seorin-cd-add]');
    if (!btn) { return; }
    var input = document.querySelector('cart-drawer input.quantity__input[data-quantity-variant-id="' + SOAP_VARIANT + '"]');
    if (!input) { return; }
    var add = parseInt(btn.getAttribute('data-seorin-cd-add'), 10) || 1;
    btn.disabled = true;
    btn.textContent = 'Aggiungo...';
    input.value = (parseInt(input.value, 10) || 0) + add;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function boot() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { return; }
    tick(); eta();
    setInterval(tick, 1000);
    /* re-rendu Dawn (innerHTML remplace) : recalcule la date ; les ecritures sont idempotentes, pas de boucle */
    new MutationObserver(function () { eta(); tick(); }).observe(drawer, { childList: true, subtree: true });
    /* panier vide -> le prochain ajout repart a 10:00 */
    if (drawer.classList.contains('is-empty')) { writeEnd(0); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
